import { inject } from '@angular/core';
import { map, take } from 'rxjs';
import { CanActivateFn } from '@angular/router';
import { WebAuthService } from 'src/app/auth/auth.service';

export const authenticatedGuard: CanActivateFn = () => {
  const authService = inject(WebAuthService);
  return authService.authenticated$.pipe(
    take(1),
    map(({ isAuthenticated }) => isAuthenticated)
  );
};
